import {combineEpics, Epic, ofType} from 'redux-observable';
import {filter, map, mergeMap, switchMap, take} from 'rxjs/operators';
import {ET_BOOKING} from "module/BSEntry/EntryTypeParams";
import {findEntryDescForModel} from "module/edesc/EntryDescUtil";
import {personFetchAllAction, personFetchAction, personResetAction, personSetTemplateIdAction} from "module/Person/action/PersonAction";
import {propertiesResponseAction} from 'module/Properties/action/PropertiesAction';
import {PropID} from 'module/Properties/enum/PropID';
import {selPropGenString} from 'module/Properties/selector/selPropGen';
import {refreshBSModelAction} from 'module/BSCollection/action/BSCollectionAction';
import axios from 'axios'
import {PersonTO} from 'generated/JavaTO'
import {PERSONS_URL} from 'module/Person/api/PersonAPI'
import {Person} from 'generated/JavaTOmodifications'
import {SisName} from 'util/SisName'
import {selEntryDescById} from 'module/edesc/selector/EntryDescSelector'
import {isBooking} from 'module/BSEntry/SisNameGuard'

const initEpicProp: Epic = (action$, state$) => action$.pipe(
	ofType(propertiesResponseAction.type),
	take(1),
	map(() => {
		const templateId = selPropGenString(PropID.evoApps_personListTemplate)(state$.value);
		return personSetTemplateIdAction(templateId || 0);
	}),
)

type PersNrModel = { persNr?: number }
const refreshPersonAfterChangedApprovalBookingEpic: Epic = (action$, state$) => action$.pipe(
	filter(refreshBSModelAction.match),
	filter(({payload: {sisName}}) => sisName === ET_BOOKING),
	mergeMap(({payload: {add, remove}}) => {
		const byId = selEntryDescById(state$.value)
		return [...new Set([...(remove || []), ...(add || [])].flatMap((model) => {
			if (!isBooking(model)) return []
			const ed = findEntryDescForModel(byId, model);
			if (!ed || !ed.approvalPze && !ed.approvalPzeKost && !ed.approvalAze) return []
			return [model.persNr]
		}))].map(persNr => personFetchAction(persNr))
	}),
)

const fetchAllEpic: Epic = (action$, state$) => action$.pipe(
	filter(personFetchAllAction.match),
	switchMap(() => {
		return axios.get<PersonTO[]>(PERSONS_URL)
			.then(({data}) => personResetAction(
				data.map(x => <Person>({...x, sisName: SisName.Person})),
			))
	}),
)

export const PersonEpic = combineEpics(initEpicProp, refreshPersonAfterChangedApprovalBookingEpic, fetchAllEpic)